import React, { useState, useEffect } from 'react'
import { Modal, Button, Input, message } from 'antd';
// import "./offerPrint.css"
import { useMaintenanceModel } from "../chargebackModel"
import { YhOfferPrint } from "@/components/YhPrint/OfferPrint/OfferPrint"
import { chargebackService } from '../chargebackService';
import { IChargebackDetail, IMaterialDetailList, IItemDetailList } from '../chargebackTypes';
import { formatNum, fmoney } from '@/utils/utils';
import { useDictModel } from '@/views/base/dict/dictModel';
export type IChargebackAndItemType = {
    total: number
    discount: number
}
export type TotalType = {
    num: number,
    total: number
}
export function OfferPrint() {
    const initDesc = { total: 0, discount: 0 }
    const totalDesc = { total: 0, num: 0 }
    const {
        offerPrint: visible,
        selectedRow,
        setOfferPrint,
        onPrinting,
    } = useMaintenanceModel();
    const [formVal, setFormVal] = useState<IChargebackDetail>();
    const [maintenanceList, setMaintenanceList] = useState<IMaterialDetailList[]>([]);
    const [itemList, setItemList] = useState<IItemDetailList[]>([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState<IChargebackAndItemType>(initDesc);
    const [itemTotal, setItemTotal] = useState<IChargebackAndItemType>(initDesc);
    const [total, setTotal] = useState<TotalType>(totalDesc);
    const { getTreeNodeName } = useDictModel();

    useEffect(() => {
        visible && getPoDetailOne()
    }, [visible])
    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await chargebackService.one(selectedRow?.returnCode as string);
        if (retData) {
            let { itemDetails, materialDetails, ...formVal } = retData;
            let newMaintenanceTotal = { ...maintenanceTotal }
            let newItemTotal = { ...itemTotal }
            let newTotal = { ...total }

            let newItemDetails: any = itemDetails?.map((item, index) => {
                newItemTotal.total += Number(item.workHour) * Number(item.price)
                newItemTotal.discount = item.discountRate as number
                let { price, discountRate, receivableAmount } = item
                return {
                    ...item,
                    No: (materialDetails ? materialDetails.length : 0) + index + 1,
                    notAmount: Number(item.workHour) * Number(item.price),
                    taxPrice: fmoney(formatNum(Number(price) * Number(discountRate) / 100), 2),
                    receivableAmount: fmoney(receivableAmount, 2)

                }
            })
            let newMaterialDetails: any = materialDetails?.map((item, index) => {
                newMaintenanceTotal.total += Number(item.num) * Number(item.price)
                newMaintenanceTotal.discount = item.discountRate as number
                let { price, discountRate, receivableAmount } = item
                return {
                    ...item,
                    No: index + 1,
                    notAmount: Number(item.num) * Number(item.price),
                    taxPrice: fmoney(formatNum(Number(price) * Number(discountRate) / 100), 2),
                    receivableAmount: fmoney(receivableAmount, 2)


                }
            })
            newItemDetails && newItemDetails?.push({
                workHour: newTotal.num,
                No: "",
                itemCode: "合计",
                receivableAmount: fmoney(formVal.totalAmount, 2)
            })
            !newItemDetails && newMaterialDetails?.push({
                num: newTotal.num,
                No: "",
                materialCode: "合计",
                receivableAmount: fmoney(formVal.totalAmount, 2)
            })
            if (retData) {
                setMaintenanceList(newMaterialDetails as IChargebackDetail[] ?? []);
                setItemList(newItemDetails as IChargebackDetail[] ?? []);
                setFormVal(formVal)
                setMaintenanceTotal(newMaintenanceTotal)
                setItemTotal(newItemTotal)
            }
        }
    };

    const onCancel = () => {
        setOfferPrint(false)
        setMaintenanceList([]);
        setItemList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const onConfirm = async () => {
        // let { id, returnCode } = selectedRow
        // await onPrinting({ id, returnCode })
    }
    const columns = [
        {
            title: '序号 No',
            dataIndex: 'No',
        },
        {
            title: '编号 Code',
            dataIndex: 'materialCode',
        },
        {
            title: '名称 Name',
            dataIndex: 'materialName',
        },
        {
            title: '英文名称 NameEn',
            dataIndex: 'materialNameEn',
        },
        {
            title: '单位 Unit',
            dataIndex: 'unitName',
        },
        {
            title: '数量 Qty',
            dataIndex: 'num',
        },
        {
            // title: '折后单价 Discounted Price',
            title: '单价 Unit price',
            dataIndex: 'taxPrice',
        },
        {
            title: '金额 Amount',
            dataIndex: 'receivableAmount',
        },
        {
            title: '备注 Remark',
            dataIndex: 'note',
        },
    ]
    const itemClumns = [
        {
            title: '序号 No',
            dataIndex: 'No',
        },
        {
            title: '编号 Code',
            dataIndex: 'itemCode',
        },
        {
            title: '名称 Name',
            dataIndex: 'itemName',

        },
        {
            title: '英文名称 NameEn',
            dataIndex: 'itemNameEn',

        },
        // {
        //     title: '规格 Spec 无',
        //     dataIndex: 'num',
        // },
        // {
        //     title: '产地 Origin 无',
        //     dataIndex: 'num',
        // },
        {
            title: '单位 Unit wu',
            dataIndex: 'unitName',
        },
        {
            title: '数量 Num',
            dataIndex: 'workHour',
        },
        // {
        //     title: '单价 Unit price',
        //     dataIndex: 'price',
        // },
        {
            // title: '折后单价 Discounted Price',
            title: '单价 Unit price',
            dataIndex: 'taxPrice',
        },
        {
            title: '金额 Sum',
            dataIndex: 'receivableAmount',
        },
        {
            title: '备注 Note',
            dataIndex: 'note',
        },
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: "报价单位 Customer name：",
                fieldValue: formVal?.customerName,
                className: "header-single"
            },
            // {
            //     fieldLabel:"",
            // },
            // {
            //     fieldLabel:"",
            // },
            // {
            //     fieldLabel:"",
            // },                        
            {
                fieldLabel: "报价单号 Quotation：",
                fieldValue: formVal?.returnCode
            },
            {
                fieldLabel: "制单员 Operator：",
                fieldValue: formVal?.createUser
            },
            {
                fieldLabel: "第1/1页",
                fieldValue: ""
            },
            {
                fieldLabel: "合计金额 Total：",
                fieldValue: fmoney(formVal?.receivableTotalAmount, 2)
            },
        ],
        footer: [
            {
                fieldLabel: "地址 Address：",
                fieldValue: formVal?.customerAddress
            },
            {
                fieldLabel: "电话 Tel：",
                fieldValue: formVal?.phone
            },
            {
                fieldLabel: "结算方式 Payment Type：",
                fieldValue: getTreeNodeName(formVal?.payType as string)
            },
            {
                fieldLabel: "备注 Remark：",
                fieldValue: formVal?.note
            },
        ],

    }
    const headerTitle = {
        titleEn: "Asia-Africa International FZE",
        title: "报价单 Quotation"
    }
    return (
        <YhOfferPrint
            title="报价单打印详情"
            type=""
            visible={visible}
            onClose={onCancel}
            onConfirm={onConfirm}
            columns={columns}
            itemClumns={itemClumns}
            itemDataSource={itemList}
            dataSource={maintenanceList}
            printShow={printShow}
            headerTitle={headerTitle}
        />
    )
}